import { useRef, useCallback } from 'react';

// ponytail: drag-to-scroll souris uniquement, seuil 5px pour ne pas bloquer les clics
export function useDragScroll() {
  const ref = useRef(null);
  const state = useRef({ down: false, startX: 0, scrollLeft: 0, dragging: false });

  const onMouseDown = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    state.current = { down: true, startX: e.pageX, scrollLeft: el.scrollLeft, dragging: false };
    el.style.cursor = 'grab';
  }, []);

  const onMouseMove = useCallback((e) => {
    const s = state.current;
    if (!s.down) return;
    const dx = e.pageX - s.startX;
    if (!s.dragging && Math.abs(dx) < 5) return;
    s.dragging = true;
    e.preventDefault();
    ref.current.scrollLeft = s.scrollLeft - dx;
    ref.current.style.cursor = 'grabbing';
  }, []);

  const onMouseUp = useCallback(() => {
    state.current.down = false;
    if (ref.current) ref.current.style.cursor = '';
  }, []);

  return { ref, onMouseDown, onMouseMove, onMouseUp, onMouseLeave: onMouseUp };
}
